import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getUygunaKiralaLocationListSaga = createAction(
  "GET_UYGUNA_KIRALA_LOCATION",
  ({ payload, params }: SagaActionParams<Type.UygunaKiralaLocationDto[]>) => ({
    payload,
    url: "/api/admin/uygunakiralalocations" + (params ? params : ""),
  })
);
export const getUygunaKiralaLocationDetailsSaga = createAction(
  "GET_UYGUNA_KIRALA_LOCATION_DETAILS",
  ({ payload, id }: SagaActionParams<Type.UygunaKiralaLocationDetailDto>) => ({
    payload,
    url: "/api/admin/uygunakiralalocations/" + id,
  })
);
export const createUygunaKiralaLocationSaga = createAction(
  "CREATE_UYGUNA_KIRALA_LOCATION",
  ({ payload, body }: SagaActionParams<Type.UygunaKiralaLocationDto>) => ({
    payload,
    url: "/api/admin/uygunakiralalocations",
    body,
  })
);
export const updateUygunaKiralaLocationSaga = createAction(
  "UPDATE_UYGUNA_KIRALA_LOCATION",
  ({ payload, id, body }: SagaActionParams<Type.UygunaKiralaLocationDto>) => ({
    payload,
    url: "/api/admin/uygunakiralalocations/" + id,
    body,
  })
);
export const deleteUygunaKiralaLocationSaga = createAction(
  "DELETE_UYGUNA_KIRALA_LOCATION",
  ({ payload, id }: SagaActionParams<Type.UygunaKiralaLocationDto>) => ({
    payload,
    url: "/api/admin/uygunakiralalocations/" + id,
  })
);

const uygunaKiralaLocationsSaga = [
  takeLatest<any>(
    getUygunaKiralaLocationListSaga.toString(),
    (payload: SagaGenericParams<Type.UygunaKiralaLocationDto[]>) =>
      getSaga<Type.UygunaKiralaLocationDto[]>(payload)
  ),
  takeLatest<any>(
    getUygunaKiralaLocationDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.UygunaKiralaLocationDetailDto>) =>
      getSaga<Type.UygunaKiralaLocationDetailDto>(payload)
  ),
  takeLatest<any>(
    createUygunaKiralaLocationSaga.toString(),
    (payload: SagaGenericParams<Type.UygunaKiralaLocationDto>) =>
      postSaga<Type.UygunaKiralaLocationDto>(payload)
  ),
  takeLatest<any>(
    updateUygunaKiralaLocationSaga.toString(),
    (payload: SagaGenericParams<Type.UygunaKiralaLocationDto>) =>
      putSaga<Type.UygunaKiralaLocationDto>(payload)
  ),
  takeLatest<any>(
    deleteUygunaKiralaLocationSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.UygunaKiralaLocationDto>(payload)
  ),
];

export default uygunaKiralaLocationsSaga;
